import React from 'react';
import Icon from '../../../components/AppIcon';

const CERTIFICATIONS = [
  { name: 'ISO 27001', description: 'Information security management', icon: 'FileCheck' },
  { name: 'PCI DSS', description: 'Payment card industry compliance', icon: 'CreditCard' },
  { name: 'SOC 2 Type II', description: 'Security & availability controls', icon: 'ServerCog' },
  { name: 'Gaming licence', description: 'Sikkim Gaming Commission', icon: 'Scale' },
];

const SAFEGUARDS = [
  {
    icon: 'Radar',
    title: 'Live fraud monitoring',
    copy: 'Real-time monitoring flags suspicious activity on accounts and tables before it reaches your balance.',
    color: '#FF3D71',
  },
  {
    icon: 'Banknote',
    title: 'Automated cashier',
    copy: 'The payout system runs at 99.9% uptime, so withdrawals do not wait for office hours or a human to wake up.',
    color: '#25D366',
  },
  {
    icon: 'Lock',
    title: 'Encrypted end to end',
    copy: '256-bit TLS on every session, tokenised payment rails, and no card details ever stored on our servers.',
    color: '#5B8CFF',
  },
  {
    icon: 'Dice5',
    title: 'Verifiable fairness',
    copy: 'Certified RNGs audited monthly, plus provably fair hashes you can check yourself on instant-win games.',
    color: '#B98CFF',
  },
];

const TrustCredentialsSection = () => (
  <section className="relative overflow-hidden py-24">
    <span className="aurora left-[-8%] top-[10%] h-96 w-96 bg-wa-green/20" aria-hidden="true" />

    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <span className="badge-pill"><Icon name="ShieldCheck" size={13} /> Credentials</span>
        <h2 className="mt-6 font-heading text-display font-bold text-white">
          Licensed, audited, <span className="gold-text">accountable</span>
        </h2>
        <p className="mt-4 text-body-lg text-white/60">
          Trust should be checkable. These are the certifications and systems standing behind every hand you play
          on Nitin Online Book.
        </p>
      </div>

      <div className="perspective mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {CERTIFICATIONS.map((c, i) => (
          <div key={c.name} className="card-3d animate-rise p-6 text-center" style={{ animationDelay: `${i * 70}ms` }}>
            <span className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl border border-royal-gold/25 bg-royal-gold/10">
              <Icon name={c.icon} size={24} color="#F0C24B" />
            </span>
            <div className="font-display text-base font-semibold text-white">{c.name}</div>
            <div className="mt-1.5 text-xs text-white/45">{c.description}</div>
          </div>
        ))}
      </div>

      <div className="mt-8 grid gap-5 md:grid-cols-2">
        {SAFEGUARDS.map((s) => (
          <div key={s.title} className="card-flat flex gap-4 p-6">
            <span
              className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl"
              style={{ background: `${s.color}1F` }}
            >
              <Icon name={s.icon} size={22} color={s.color} />
            </span>
            <div>
              <h3 className="font-display text-base font-semibold text-white">{s.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-white/55">{s.copy}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustCredentialsSection;
